import React from 'react';

import { styled } from '../theme';
import SvgIcon from './SvgIcon';
import Text from './Text';

type Props = {
    name: string;
    value: any;
    checked?: boolean;
    disabled?: boolean;
    onChange?: (ev: any) => void;
};

const Container = styled('label')<Props>(({ disabled }) => ({
    cursor: disabled ? 'default' : 'pointer',
    padding: '0 8px 0 0',
    '> *': {
        verticalAlign: 'middle',
    },
}));

const Label = styled(Text)<Props>(({ disabled }) => ({
    fontSize: '1.6rem',
    ...(disabled && { color: '#B9BABA' }),
}));

const StyledInput = styled('input')<Props>({
    display: 'none',
});

const StyledIcon = styled(SvgIcon)<Props>({
    display: 'inline-block',
    margin: '0 8px 0 0',
});

const Radio: React.FC<Props> = ({
    checked = false,
    disabled = false,
    children,
    onChange,
    value,
    name,
    ...props
}) => (
    <Container {...props} className={props.className}>
        <StyledInput
            type="radio"
            name={name}
            value={value}
            disabled={disabled}
            onChange={onChange}
        />
        <StyledIcon
            src={checked && !disabled ? '/icons/ic-radio-selected.svg' : '/icons/ic-radio.svg'}
            width={24}
            height={24}
        />
        <Label disabled={disabled}>{children}</Label>
    </Container>
);

export default Radio;
